import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, MenuItem } from "@mui/material";
import RowEditableTable from "../../../../../../../components/Tables/RowEditableTable";
import { secondAxios } from "../../../../../../../api/axios";
import {
  createDocumentList,
  getProjectDocumentList,
  getPlantDocumentList,
  updateDocumentList,
  deleteDocumentList,
} from "./docListAPI";
import EditableTable from "../../../../../../../components/Tables/EditableTable";
import { useDCS } from "../DCSContext";
// Sample data for demonstration
// export const sampleDocuments = [
//   {
//     number: 1,
//     department: "Piping",
//     docNumber: "DOC001",
//     title: "Employee Handbook",
//     responsible: "Ahmed Osama",
//   },
//   {
//     number: 2,
//     department: "Structure",
//     docNumber: "DOC002",
//     title: "Annual Report",
//     responsible: "Omar Mokhtar",
//   },
//   {
//     number: 3,
//     department: "Structure",
//     docNumber: "DOC003",
//     title: "Security Policy",
//     responsible: "Ahmed Samy",
//   },
// ];
const departments = [
  "Piping",
  "Structure",
  "Vendor",
  "Tank",
  "Pressure Vessel",
];

export const DocLsitInitialData = {
  number: "",
  department: "",
  title: "",
  responsible: "",
  projectId: "",
};

export const DocListColumns = (allUsers, type, plantProjects = []) => {
  const columns = [
    {
      accessorKey: "docNumber",
      header: `#`,
      size: 20,
    },
  ];

  // Add project column if in plant mode
  if (plantProjects && plantProjects.length > 0) {
    columns.push({
      accessorKey: "projectId",
      header: "Project",
      size: 30,
      enableEditing: true,
      muiEditTextFieldProps: () => ({
        children: plantProjects.map((project) => (
          <MenuItem
            key={project.id || project.name}
            value={project.id || project.name}
          >
            {project.name || "Unnamed Project"}
          </MenuItem>
        )),
        select: true,
      }),
      Cell: ({ cell, row }) => {
        const projectId = cell.getValue();
        const project = plantProjects.find(
          (p) => (p.id || p.name) === projectId
        );
        return project?.name || projectId || "-";
      },
    });
  }

  columns.push(
    {
      accessorKey: "department",
      header: `Department`,
      enableEditing: true,
      muiEditTextFieldProps: () => ({
        children: departments.map((dep, index) => (
          <MenuItem key={index} value={dep}>
            {dep}
          </MenuItem>
        )),
        select: true,
      }),
      size: 30,
    },
    {
      accessorKey: "title",
      header: "Description",
      size: 40,
    },
    {
      accessorKey: "responsible",
      header: "Responsible",
      size: 90,
      enableSorting: false,
      muiEditTextFieldProps: () => ({
        children: allUsers.map((user) => (
          <MenuItem key={user.email} value={user.email}>
            {user.name}
          </MenuItem>
        )),
        select: true,
      }),
      Cell: ({ cell, row }) => {
        return cell.getValue();
      },
    }
  );

  return columns;
};

const DocumentList = ({ open, handleClose, documents }) => {
  // const [allUsers, setAllUsers] = useState([]);
  const {
    allUsers,
    documentList,
    type,
    id: projId,
    plant,
    plantId,
    plantProjects,
  } = useDCS();

  // Wrapper function for createItem that handles plant mode
  const handleCreateItem = async (parentId, item) => {
    // In plant mode, extract projectId from the item
    if (plant && plantId && item.projectId) {
      const selectedProjectId = item.projectId;
      // Remove projectId from item before sending to API
      const { projectId, ...docData } = item;
      return createDocumentList(type, selectedProjectId, docData);
    }
    // In project mode, use parentId as projectId
    return createDocumentList(type, parentId, item);
  };

  useEffect(() => {
    // const getAllUsers = async () => {
    //   const users = (await secondAxios.get("/user")).data;
    //   console.log(users);
    //   setAllUsers(users);
    // };
    // getAllUsers();
  }, []);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 1100,
          bgcolor: "background.paper",
          //   border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Document List
        </Typography>
        {/* <RowEditableTable
          columns={DocListColumns(allUsers)}
          data={documentList}
          handleCreateRow={handleCreateRow}
        /> */}
        <EditableTable
          name="Doc List"
          displayMode="row"
          columns={DocListColumns(
            allUsers,
            type,
            plant && plantProjects ? plantProjects : []
          )}
          enableEditing={true}
          enableCreate={true}
          initialData={
            plant && plantProjects && plantProjects.length > 0
              ? { ...DocLsitInitialData, projectId: "" }
              : DocLsitInitialData
          }
          api={{
            getItems:
              plant && plantId
                ? getPlantDocumentList.bind(null, type, plantId)
                : getProjectDocumentList.bind(null, type),
            createItem: handleCreateItem,
            updateItem: updateDocumentList,
            deleteItem: deleteDocumentList,
          }}
          parentId={plant && plantId ? plantId : projId}
        />
      </Box>
    </Modal>
  );
};

export default DocumentList;
